import React, { useEffect, useRef } from 'react';
import Modal from 'components/modal/modalComponent';
import { useApolloClient } from '@apollo/client';

interface VeradigmModalProps {
  isOpen: boolean;
  token?: string;
  callback?: () => Promise<void>;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

const VeradigmModal: React.FC<VeradigmModalProps> = ({
  isOpen,
  setIsOpen,
  token,
  callback = () => ({}),
}) => {
  const client = useApolloClient();

  const onClose = async () => {
    try {
      await callback();
      await client.refetchQueries({
        include: ['GetMedicationByProfileTabPatientCodexId'],
      });
    } finally {
      setIsOpen(false);
    }
  };

  const formRef = useRef<HTMLFormElement>(null);

  useEffect(() => {
    if (isOpen && formRef.current) {
      formRef.current.submit();
    }
  }, [isOpen]);

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="ePrescribe"
      titleContainerMinHeight="desktop:min-h-[50px]"
      modalDesktopWidth="desktop:min-w-[1200px] desktop:max-w-[1200px]"
      customContentContainerClass="h-[80vh]  !px-1 !py-0"
    >
      <iframe
        style={{ width: '100%', height: '100%', border: 'none' }}
        name="veradigmFrame"
        title="Veradigm E-Prescribe"
      />

      <form
        ref={formRef}
        method="POST"
        target="veradigmFrame"
        action="https://eprescribeqa.allscripts.com/sso/jwtsso.aspx"
        style={{ display: 'none' }}
      >
        <input type="hidden" name="jwt" value={token} />
      </form>
    </Modal>
  );
};

export default VeradigmModal;
